import { makeStyles } from '@material-ui/core/styles'

export const ManageWidgetsStyles = makeStyles((theme) => ({
  appBarIcon: {
    color: theme.palette.components.topBarIcon,
    fontSize: '24px',
  },
  tab: {
    minWidth: 30,
    paddingLeft: 0,
    paddingRight: 0,
    maxWidth: '320px',
  },
  helperText: {
    marginRight: theme.spacing(1),
  },
}))
